(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-floorball/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-floorball/assets/javascripts/init-box.js'); 
var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_floorball = svs.themes.sport_floorball || {};

  svs.themes.sport_floorball.initStatusStart = function(data) {
    if (svs.themes.sport_floorball.isLive(data.status.id)) {
      if (data.status.id === 1) {
        return '<div class="brick match-status brick-active f-condensed align-center">1:A</div>';
      }
      if (data.status.id === 2) {
        return '<div class="brick match-status brick-active f-condensed align-center">2:A</div>';
      }
      if (data.status.id === 3) {
        return '<div class="brick match-status brick-active f-condensed align-center">3:E</div>';
      }
      if (data.status.id === 19) {
        return '<div class="brick match-status brick-active f-condensed align-center">ÖT</div>';
      }
      if (data.status.id === 22) {
        return '<div class="brick match-status brick-active f-condensed align-center">STR</div>';
      }
      if (
        data.status.id === 14 ||
        data.status.id === 16  ||
        data.status.id === 18 
      ) {
        return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
      }

      return '<div class="brick match-status brick-active f-condensed align-center">1:A</div>';
    } else if (svs.themes.sport_floorball.isEnded(data.status.id)) {
      if (data.status.id === 32) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">ÖT</div>';
      }
      if (data.status.id === 33) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">STR</div>';
      }
      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">FT</div>';
    } else if (data.startTime) {
      return (
        '<div class="brick match-status brick-border f-condensed align-center">' +
        svs.themes.formatTime(data.startTime) +
        '</div>'
      );
    }
    return '';
  };

  svs.themes.sport_floorball.hasMatchMinutes = function() {
    return false;
  };
})(svs);

 })(window);